module.exports = __webpack_public_path__ + "img/warning_white_24dp.d44dc837.svg";